var _rect, _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestbill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 19,
    stroke: "#74A3C7",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H13",
    stroke: "#74A3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H13",
    stroke: "#74A3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H13",
    stroke: "#74A3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13H8",
    stroke: "#74A3C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 17.5,
    r: 4,
    fill: "#F1F6F9",
    stroke: "#74A3C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0234 20.6364H13.4908L13.4933 20.0771C14.5447 20 15.1463 19.3984 15.1463 18.593C15.1463 17.6758 14.3285 17.3203 13.6822 17.1612L13.5007 17.114L13.5057 15.5181C13.9705 15.5803 14.2887 15.8388 14.3359 16.2464H15.0767C15.0568 15.4883 14.4304 14.9215 13.5082 14.8469L13.5107 14.2727H13.0433L13.0408 14.8519C12.1484 14.9414 11.4947 15.4982 11.4947 16.3011C11.4947 17.0096 12.0018 17.4247 12.8196 17.646L13.0334 17.7031L13.0284 19.396C12.5437 19.3363 12.1683 19.0728 12.1286 18.593H11.358C11.4052 19.4506 12.0241 20.0025 13.0259 20.0771L13.0234 20.6364ZM13.4957 19.396L13.5007 17.8324C14.0053 17.9716 14.3857 18.1555 14.3857 18.5856C14.3857 19.0206 14.0227 19.3263 13.4957 19.396ZM13.0359 16.9897C12.6655 16.8803 12.2578 16.6839 12.2603 16.2564C12.2603 15.8835 12.5561 15.5927 13.0384 15.5206L13.0359 16.9897Z",
    fill: "#74A3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestbill);
export default __webpack_public_path__ + "static/media/requestbill.6b1de7d588adc46e8264163fd08946d8.svg";
export { ForwardRef as ReactComponent };